import { Home } from './Home';

export const HomeApp = () => {
  return <Home />;
};
